<template>
    <button type="button" class="btn btn-outline-primary w-100" :class="{[`btn-${size}`]: true}" @click.prevent="notifyModal()">
        {{ $t('Notify me') }}
    </button>
</template>

<script setup>
const ProductNotifyModal = defineAsyncComponent(() => import("~/components/Modals/ProductNotifyModal.vue"));

const props = defineProps({
    size: {
        type: String,
        default: 'lg'
    },
    product_id: Number,
});

const notifyModal = () => useModal().openModal('ProductNotifyModal', ProductNotifyModal, {product_id: props.product_id})
</script>
